import React from "react";
import "./scrollTop.css";
import Fab from "../fab/fab";
import { history } from "../../store/store";
import { withRouter } from "react-router-dom";

const SHOW_AFTER_PX = 600;

// Scrollable areas that are not "the page": the API docs menu and the try-out window.
const IGNORED_SCROLLERS = ".menu-content, .moveBox__window";

// Some pages scroll the window, others (products, blog, FAQ) an inner panel; scroll events do
// not bubble, so listen in the capture phase and track whichever page-sized area moved last.
const getPageScroller = (target) => {
  if (target === document || target === document.documentElement) {
    return document.scrollingElement;
  }
  if (!(target instanceof Element) || target.closest(IGNORED_SCROLLERS)) {
    return null;
  }
  return target.clientHeight >= window.innerHeight / 2 ? target : null;
};

class ScrollToTop extends React.Component {
  state = { visible: false };

  scroller = null;

  componentDidMount() {
    document.addEventListener("scroll", this.onScroll, {
      capture: true,
      passive: true,
    });
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.onScroll, { capture: true });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
      this.scroller = null;
      if (this.state.visible) this.setState({ visible: false });
    }
  }

  onScroll = (event) => {
    const scroller = getPageScroller(event.target);
    if (!scroller) return;
    this.scroller = scroller;
    const visible = scroller.scrollTop > SHOW_AFTER_PX;
    if (visible !== this.state.visible) this.setState({ visible });
  };

  onClick = () => {
    const behavior = !history.location.pathname.startsWith("/documentation/")
      ? "smooth"
      : "auto";
    const scroller = this.scroller || document.scrollingElement;
    scroller.scrollTo({ top: 0, behavior });
    if (scroller !== document.scrollingElement) {
      window.scrollTo({ top: 0, behavior });
    }
  };

  render() {
    return (
      <Fab
        weight={-1}
        onClick={this.onClick}
        className={`back-to-top${
          this.state.visible ? " back-to-top--visible" : ""
        }`}
      >
        <span role="button" aria-label="Back to top">
          ↑
        </span>
      </Fab>
    );
  }
}

export default withRouter(ScrollToTop);
